import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

const KEY = "areeba_cart_v1";

function load() {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
}

export function CartProvider({ children }) {
  const [items, setItems] = useState(load);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const addItem = useCallback((product, variant, qty = 1) => {
    setItems((prev) => {
      const idx = prev.findIndex((i) => i.sku === variant.sku);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], quantity: next[idx].quantity + qty };
        return next;
      }
      return [
        ...prev,
        {
          product_id: product.id,
          slug: product.slug,
          name: product.name,
          sku: variant.sku,
          pack_size: variant.pack_size,
          price: variant.price,
          mrp: variant.mrp,
          image: (product.images || [])[0],
          quantity: qty,
        },
      ];
    });
  }, []);

  const setQty = useCallback((sku, qty) => {
    setItems((prev) =>
      prev
        .map((i) => (i.sku === sku ? { ...i, quantity: Math.max(1, qty) } : i))
        .filter((i) => i.quantity > 0)
    );
  }, []);

  const removeItem = useCallback((sku) => {
    setItems((prev) => prev.filter((i) => i.sku !== sku));
  }, []);

  const clear = useCallback(() => setItems([]), []);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const lines = items.map((i) => ({ product_id: i.product_id, sku: i.sku, quantity: i.quantity }));

  return (
    <CartContext.Provider
      value={{ items, count, subtotal, lines, addItem, setQty, removeItem, clear, open, setOpen }}
    >
      {children}
    </CartContext.Provider>
  );
}
